import { Button, Spin } from 'aa_common/front-end/antd'
import { ExportModal } from 'aa_common/front-end/components'
import { Pagination, Radio } from 'antd'
import { CORPORATE_INCOME_TAX, CORPORATE_INCOME_TAX_REPORT_DATA, StatusJob } from 'common/constants'
import { getNs } from 'common/i18n-config'
import querystring from 'query-string'
import { useLocation } from 'react-router-dom'

import { useCorporateIncomeTaxDetail } from '../hooks/use-corporate-income-tax-detail'
import { usePagination } from '../hooks/use-pagination'
import { detailReportSlice } from '../store'
import { StyledWrapperContent, StyledWrapperContentSVG, StyledWrapperTop } from '../styles'
import { DetailedReport } from './detailed-report'

const { t, useNsReady } = getNs(['common', 'pages/accounting/corporate-income-tax-report'])

interface Props {
  reportId: number
  termId: number
  reportType: number
}

export const CorporateIncomeTaxDetail = ({ reportId, termId, reportType }: Props) => {
  useNsReady()

  const location = useLocation()
  const { pagination } = detailReportSlice.useSlice(state => state?.filters) || {}
  const { reportData, loading } = detailReportSlice.useSlice(state => ({
    reportData: state?.data,
    loading: state?._loading,
  }))

  const { id: reportNumber } = querystring.parse(location.search)
  const isReportNo8 = reportNumber && +reportNumber === CORPORATE_INCOME_TAX.TABLE_16_TYPE_8
  const isHaveReportData = reportData && Object.keys(reportData).length > 0

  const { exportType, handleExport, triggerExport, handleExportTypeChange, isShowModal, setIsShowModal, exportStatus } =
    useCorporateIncomeTaxDetail(termId, reportId, reportType)
  const { getPagination } = usePagination()

  return (
    <StyledWrapperContent>
      <Spin loading={loading || exportStatus === StatusJob.JobStatusWaiting}>
        <StyledWrapperTop data-testid="coporatetax-income">
          {!isReportNo8 && <Pagination {...getPagination(pagination, t('page'))} />}
          <div className="right-content">
            <Radio.Group onChange={handleExportTypeChange} value={exportType}>
              <Radio value="pdf">
                <span>PDF {t('export_format')}</span>
              </Radio>
              <Radio value="csv">
                <span data-testid="radio-csv">CSV {t('export_format')}</span>
              </Radio>
            </Radio.Group>

            <Button data-testid="export-button" color="grey" onClick={handleExport} disabled={!isHaveReportData}>
              {t('actions.export')}
            </Button>
          </div>
        </StyledWrapperTop>
        <ExportModal
          isShow={isShowModal}
          onCancel={() => setIsShowModal(false)}
          title={t('titleModalCsv', {
            typeReport: CORPORATE_INCOME_TAX_REPORT_DATA[+reportId as CORPORATE_INCOME_TAX] ?? '',
          })}
          onExport={triggerExport}
        />
        <StyledWrapperContentSVG>
          <DetailedReport reportId={reportId} />
        </StyledWrapperContentSVG>
      </Spin>
    </StyledWrapperContent>
  )
}

export enum EXPORT_TYPE {
  PDF = 'pdf',
  CSV = 'csv',
}
